// components
import { CasCRUDTable } from 'src/compass/shared/components';
import {
  CasRenderBoolTrue,
  CasRenderBoolTrueFalse,
} from 'src/compass/shared/components/CasTable/CellRender/CasRenderBool';
import { CasYesNoSelect } from 'src/compass/application';
// Modal
import BranchForm from './_internal/BranchForm';

type BranchTabProps = {
  readOnly?: boolean;
};

export default function BranchTab({ readOnly = false }: BranchTabProps) {
  return (
    <CasCRUDTable
      entityTitle="Branch"
      entity="Branch"
      showAddButton={!readOnly}
      columns={[
        {
          field: 'name',
          showEditOnclick: !readOnly,
        },
        {
          field: 'isMainOffice',
          label: 'Main office',
          render: CasRenderBoolTrue,
        },
        {
          field: 'insAgencyName',
          label: 'Agency',
        },
        {
          field: 'eHarvestAliasUser',
          label: 'eHarvest User',
        },
        {
          field: 'isActive',
          label: 'Active',
          render: CasRenderBoolTrueFalse,
        },
      ]}
      filters={[
        {
          name: 'searchName',
          label: 'Name',
        },
        {
          type: 'component',
          name: 'isActive',
          label: 'Active',
          initialValue: true,
          includeAllOption: true,
          component: CasYesNoSelect,
        },
      ]}
      editForm={BranchForm}
    />
  );
}
